module.exports = __webpack_public_path__ + "static/img/about4.6516749.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/about4.jpg
// module id = N17v
// module chunks = 3